import { render } from "./one.vue?vue&type=template&id=77a6b20c&scoped=true"
import script from "./one.vue?vue&type=script&lang=js"
export * from "./one.vue?vue&type=script&lang=js"

import "./one.vue?vue&type=style&index=0&id=77a6b20c&scoped=true&lang=css"

import exportComponent from "D:\\vue.js-tut\\czn\\online\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77a6b20c"]])

export default __exports__